import { CreateUniqId, useScrollToTop } from "../../Utility";
import { Suspense, lazy } from "react";
import { RenderLoadingSpinnerInImageTag } from "../LoggedInComponents/Helper";

// * import method different because its a lazy load import
const Hero = lazy(() => import("./Hero"));
const BottomQuickLinks = lazy(() => import("./BottomQuickLinks"));

export default function Home() {
  // * At the top of the page.
  useScrollToTop();

  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg) {
    return (
      <Suspense
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }

  return (
    <>
      <div key={CreateUniqId("Parent-", "-Home")} className=" min-h-screen">
        {returnComponentWithLazySetup(<Hero />, "Loading Home Page...")}

        {returnComponentWithLazySetup(
          <BottomQuickLinks />,
          "Loading email Subscribe module..."
        )}
      </div>
    </>
  );
}
